import { apiSlice } from "@/redux/rtk/features/apiSlice/apiSlice";
import { toastHandler } from "@/utils/functions";
import queryGenerator from "@/utils/queryGenarator";

export const interestApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getInterest: builder.query({
      query: ({ id }) => ({
        url: `interest/${id}`,
      }),
      providesTags: ["Interest"],
    }),
    getInterests: builder.query({
      query: () => ({
        url: `interest?query=all`,
      }),
      providesTags: ["InterestAll"],
    }),
    getInterestsPaginated: builder.query({
      query: (arg) => {
        const query = queryGenerator(arg);
        return {
          url: `interest?${query}`,
        };
      },
      providesTags: ["Interests"],
    }),

    addInterest: builder.mutation({
      query: (values) => ({
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `interest`,
        body: values,
      }),

      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          await queryFulfilled;
          toastHandler("Interest added successfully", "success");
        } catch (err) {
          toastHandler("Something went wrong, Please try again", "warning");
        }
      },
      invalidatesTags: ["Interests", "InterestAll"],
    }),

    deleteInterest: builder.mutation({
      query: ({ id }) => ({
        url: `interest/${id}`,
        method: "DELETE",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        body: {
          status: "false",
        },
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          await queryFulfilled;
          toastHandler("Deleted Interest successfully", "warning");
        } catch (err) {
          toastHandler("Something went wrong, Please try again", "warning");
        }
      },
      invalidatesTags: ["Interest", "Interests", "InterestAll"],
    }),

    updateInterest: builder.mutation({
      query: ({ id, values }) => ({
        url: `interest/${id}`,
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        body: values,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          await queryFulfilled;
          toastHandler("Interest updated successfully", "success");
        } catch (err) {
          toastHandler("Something went wrong, Please try again", "warning");
        }
      },
      invalidatesTags: ["Interest", "Interests", "InterestAll"],
    }),
  }),
});

export const {
  useGetInterestQuery,
  useGetInterestsQuery,
  useAddInterestMutation,
  useDeleteInterestMutation,
  useUpdateInterestMutation,
  useGetInterestsPaginatedQuery,
} = interestApi;

